// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"494":"abb7ec8a","834":"abb7ec8a","841":"abb7ec8a"}[chunkId] + ".chunk.css";
};